import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import CircularLoading from "@/components/circular-loading";

const appendIfPresent = (
  params: URLSearchParams,
  key: string,
  value: string | null,
) => {
  if (value) params.set(key, value);
};


export default function PaymentCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const isCanceled = searchParams.get("cancel") === "true";
    const redirectParams = new URLSearchParams();

    redirectParams.set("status", isCanceled ? "failed" : "success");
    appendIfPresent(redirectParams, "transactionId", searchParams.get("transactionId"));
    appendIfPresent(redirectParams, "price", searchParams.get("price"));
    appendIfPresent(redirectParams, "courseName", searchParams.get("courseName"));
    appendIfPresent(redirectParams, "createdAt", searchParams.get("createdAt"));
    appendIfPresent(redirectParams, "miniAppUuid", searchParams.get("miniAppUuid"));
    appendIfPresent(redirectParams, "courseId", searchParams.get("courseId"));

    if (isCanceled) {
      redirectParams.set("reason", "پرداخت توسط کاربر لغو شد.");
    } else {
      appendIfPresent(redirectParams, "reason", searchParams.get("reason"));
    }

    navigate(`/payment?${redirectParams.toString()}`, { replace: true });
  }, [navigate, searchParams]);

  return <CircularLoading />;
}
